import { Component } from 'react';

/**
 * Lazy-loads a store's full per-product Distribución Numérica when the drawer opens (or the store changes).
 */
export default class StoreDnDrawerController extends Component {
    componentDidUpdate() {
        const { open, storeId } = this.props;
        if (open && storeId && storeId !== this.state.loadedId && !this.state.loading) {
            this.load(storeId);
        }
    }

    async load(storeId) {
        this.setState({ loading: true, loadedId: storeId, data: null });
        try {
            const res = await this.props.data.fetchNumericDistributionStoreProducts({ storeId, ...(this.props.params || {}) });
            this.setState({ data: res?.data || null, loading: false });
        } catch {
            this.setState({ loading: false });
        }
    }

    setQuery(q) {
        this.setState({ q });
    }

    // Products matching the search box (name or category), plus how many are present right now.
    productRows() {
        const { data, q } = this.state;
        const all = data?.products || [];
        const term = q.trim().toLowerCase();
        const rows = term ? all.filter((p) => p.name.toLowerCase().includes(term) || (p.category || '').toLowerCase().includes(term)) : all;
        return { all, rows, presentNow: all.filter((p) => p.current).length };
    }
}
